import React from 'react';
import ReactECharts from 'echarts-for-react';
import type { EChartsOption } from 'echarts';
import { Empty } from 'antd';
import Loading from './Loading';
import ErrorFallback from './ErrorFallback';

interface ChartCardProps {
  title?: string;
  extra?: React.ReactNode;
  option: EChartsOption;
  loading?: boolean;
  error?: Error | null;
  onRetry?: () => void;
  height?: number;
  echartsGroup?: string;
}

const ChartCard: React.FC<ChartCardProps> = React.memo(({
  title,
  extra,
  option,
  loading = false,
  error = null,
  onRetry,
  height = 400,
  echartsGroup,
}) => {
  const hasHeader = title || extra;
  const header = hasHeader ? (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
      {title ? (
        <div style={{ fontSize: '0.9rem', fontWeight: 600, color: '#374151' }}>
          {title}
        </div>
      ) : <div />}
      {extra}
    </div>
  ) : null;

  if (loading) {
    return (
      <div style={{ background: '#fff', borderRadius: 8, border: '2px solid #d9d9d9', padding: 24 }}>
        {header}
        <Loading />
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ background: '#fff', borderRadius: 8, border: '2px solid #d9d9d9', padding: 24 }}>
        {header}
        <ErrorFallback message={error.message} onRetry={onRetry} />
      </div>
    );
  }

  if (!option || Object.keys(option).length === 0) {
    return (
      <div style={{ background: '#fff', borderRadius: 8, border: '2px solid #d9d9d9', padding: 24 }}>
        {header}
        <Empty description="暂无数据" />
      </div>
    );
  }

  return (
    <div style={{ background: '#fff', borderRadius: 8, border: '2px solid #d9d9d9', padding: 24 }}>
      {header}
      <ReactECharts
        option={option}
        style={{ height }}
        opts={{ renderer: 'canvas' }}
        notMerge={true}
        onChartReady={(instance) => {
          if (echartsGroup) {
            instance.group = echartsGroup;
          }
        }}
      />
    </div>
  );
});

export default ChartCard;
